import { Client } from "./_clientService";

export const getCoinOVRInfo = async () => {
  const resp = await new Client({ path: "/misc/ovr-coin/info" }).post();
  return resp;
};

export const updateCoinOVRInfo = async (payload: any) => {
  const resp = await new Client({
    path: "/misc/ovr-coin/update",
    payload,
  }).patch();
  return resp;
};

export const getConfigurations = async () => {
  const resp = await new Client({
    path: "/misc/allMiscConfig",
  }).get();
  return resp;
};

export const createAndUpdateConfig = async (payload: any) => {
  const resp = await new Client({
    path: "/misc/createUpdateMiscConfig",
    payload,
  }).post();
  return resp;
};

export const getAllUsers = async (payload: any) => {
  const { pageSize: limit, ...rest } = payload;
  const resp = await new Client({
    path: "/user/allUsers",
    payload: {
      limit,
      ...rest,
    },
  }).post();
  return resp;
};

export const getSingleUser = async (userId: any) => {
  const resp = await new Client({
    path: "/user/single/" + userId,
  }).get();
  return resp;
};

export const unblockCredit = async (userId: string) => {
  const resp = await new Client({
    path: `/user/${userId}/unblockCredit`,
  }).post();
  return resp;
};

export const generateAdminCredentials = async () => {
  const resp = await new Client({
    path: "/misc/generateAdminCredentials",
  }).post();
  return resp;
};

export const toggleWorldCupMode = async (isEnabled: boolean) => {
  const resp = await new Client({
    path: "/misc/worldCupMode/toggle",
    payload: { isEnabled },
  }).post();
  return resp;
};

export const getStandardOddsKeys = async (): Promise<string[]> => {
  const resp = await new Client({
    path: "/misc/standard-odds-keys",
  }).get();
  return resp?.data ?? [];
};
